/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// Import Swiper and required modules
// Swiper is available globally
// Swiper modules are available globally

// Import Swiper styles
// Swiper CSS is included globally

(function () {
    "use strict";

    let swipers = []; // Keep track of all initialized swipers
    let isAuthor = false;
    let carouselAnimations = new Map(); // Track carousel animations

    /**
     * Initialize Content Card Carousels
     */
    function initContentCardCarousels() {
        // Find all carousel components on the page
        const carousels = document.querySelectorAll(
            ".cmp-flindersonline-contentcard-carousel"
        );

        if (carousels.length === 0) return;


        // Destroy any existing swipers before reinitializing
        swipers.forEach((swiper) => {
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
            }
        });
        swipers = [];

        // Clean up any existing videos
        const existingVideos = document.querySelectorAll('.video-player');
        existingVideos.forEach((video) => {
            video.pause();
            video.src = '';
            video.load();
        });

        // Initialize each carousel
        carousels.forEach(function (carousel, index) {		
	        isAuthor = carousel.dataset.author === 'true';

            initSingleCarousel(carousel, index);
        });
    }

    /**
     * Initialize a single carousel instance
     * @param {HTMLElement} carousel - The carousel container element
     * @param {number} index - The index of the carousel
     */
    function initSingleCarousel(carousel, index) {
        // Add unique class for targeting
        carousel.classList.add(`carousel-${index}`);

        // Hide the entire carousel initially to prevent cards appearing in normal layout
        carousel.style.opacity = '0';
        carousel.style.visibility = 'hidden';
        
        // Ensure swiper wrapper is hidden to prevent FOUC
        const initialSwiperWrapper = carousel.querySelector('.swiper-wrapper');
        
        if (initialSwiperWrapper && !initialSwiperWrapper.classList.contains('swiper-wrapper-author')) {
            initialSwiperWrapper.style.visibility = 'hidden'; // Prevent flash of unstyled content
        }

        // Get the swiper container - match the structure used in the feature tile component
        const swiperContainer = carousel.querySelector(".swiper-container");

        if (!swiperContainer) {
            console.error(`No swiper container found for carousel ${index}`);
            return;
        }

        // Get navigation elements
        const prevButton = carousel.querySelector(".contentcard-prev");
        const nextButton = carousel.querySelector(".contentcard-next");

        // Clear any inline styles that might be interfering
        const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
        if (swiperWrapper) {
            // Remove any inline styles to allow CSS to control width
            swiperWrapper.removeAttribute("style");
        }

		let cardWidth = '';

        // Ensure slides respect their container width
        const slides = carousel.querySelectorAll(".swiper-slide");
        slides.forEach((slide) => {
            slide.removeAttribute("style");
			cardWidth = slide.dataset.cardWidth;

            // Get width class from the container
            const container = slide.querySelector(
                ".contentcard-tile-container"
            );
            if (container) {
                if (container.classList.contains("tile-narrow")) {
                    slide.style.width = "260px";
                } else if (container.classList.contains("tile-wide")) {
                    slide.style.width = "355px";
                }
            }
        });

        // Initialize Swiper
        try {

            const swiper = new Swiper(swiperContainer, {
                // Register Swiper modules
                // Essential parameters
                slidesPerView: "auto", // This is crucial - let slides determine their own width
                spaceBetween: 24,
                // grabCursor: true,
                watchOverflow: true,
				watchSlidesProgress: true,

                // Navigation buttons
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                },

                // Responsive breakpoints - match your feature tile component
                breakpoints: {
                    // Mobile - show partial next slide
                    320: {
                        slidesPerView: "auto", // Keep auto view on mobile too
                        spaceBetween: 16,
                        navigation: {
                            enabled: false
                        }
                    },
                    // Tablet
                    768: {
                        slidesPerView: "auto", // Keep auto view on tablet
                        spaceBetween: 20,
                        navigation: {
                            enabled: true
                        }
                    },
                    // Desktop
                    1024: {
                        slidesPerView: "auto", // Keep auto view on desktop
                        spaceBetween: 24,
                        navigation: {
                            enabled: true
                        }
                    },
                    // Large Desktop
                    1280: {
                        slidesPerView: "auto", // Keep auto view on large desktop
                        spaceBetween: 24
                    }
                },

                // Run this after initialization to ensure width settings are applied
                on: {
                    init: function () {
                        // Fix slide widths after Swiper has initialized
                        setTimeout(() => {
                            fixSlideWidths(carousel);
                            
                            // Show the swiper wrapper first to prevent layout shift
                            const swiperWrapper = carousel.querySelector('.swiper-wrapper');
                            if (swiperWrapper && !swiperWrapper.classList.contains('swiper-wrapper-author')) {
                                swiperWrapper.style.visibility = 'visible';
                            }
                            
                            // Show the entire carousel with smooth transition after full initialization
                            carousel.style.transition = 'opacity 0.5s ease, visibility 0.5s ease';
                            carousel.style.opacity = '1';
                            carousel.style.visibility = 'visible';
                            
                            // Initialize carousel-specific animations
                            initCarouselAnimations(carousel);
                        }, 100);
                    },
                    resize: function () {
                        // Fix slide widths again after resize
                        fixSlideWidths(carousel);
                        
                        // No need to refresh animations - they're independent
                    }
                }
            });

            // Add the swiper instance to our tracking array
            swipers.push(swiper);

			if (cardWidth === 'narrow') {
				if (slides.length <= 4 && carousel.querySelector(".carousel-navigation")) {
                	carousel.querySelector(".carousel-navigation").style.display = "none";
            	}
			} else {
				if (slides.length <= 3 && carousel.querySelector(".carousel-navigation")) {
                	carousel.querySelector(".carousel-navigation").style.display = "none";
            	}
			}

            // Setup card interactions
            setupCardInteractions(carousel);

        } catch (error) {
            console.error(
                `Error initializing Swiper for carousel ${index}:`,
                error
            );
        }
    }

    /**
     * Initialize carousel-specific animations (completely independent of global scroll animations)
     * @param {HTMLElement} carousel - The carousel container
     */
    function initCarouselAnimations(carousel) {
        if (isAuthor) return;
        if (carousel._hasAnimated) return;

        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
        // ScrollTrigger is now registered globally in scrolltrigger-config.js

        // Kill any existing animations for this carousel
        const carouselId = carousel.id || carousel.className || 'unknown';
        if (carouselAnimations.has(carouselId)) {
            const existingAnimations = carouselAnimations.get(carouselId);
            existingAnimations.forEach(animation => {
                if (animation && animation.kill) {
                    animation.kill();
                }
            });
        }

        // Find elements
        const title = carousel.querySelector('.contentcard-title');
        const nav = carousel.querySelector('.nav-wrapper');
        const slides = carousel.querySelectorAll('.swiper-slide');
        if (!title || !nav || slides.length === 0) {
            console.warn('Missing title, nav, or slides in carousel');
            return;
        }

        // Set initial state
        gsap.set([title, nav], { y: 80, opacity: 0, visibility: 'visible' });
        gsap.set(slides, { y: 200, opacity: 0, visibility: 'visible' });

        // Timeline for sequential animation
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: carousel,
                start: 'top 80%',
                once: true,
                toggleActions: 'play none none none',
                onEnter: () => { carousel._hasAnimated = true; },
            }
        });

        tl.to(title, {
            y: 0,
            opacity: 1,
            duration: 0.7,
            ease: 'power2.out',
        })
        .to(nav, {
            y: 0,
            opacity: 1,
            duration: 0.7,
            ease: 'power2.out',
        }, '-=0.4') // Overlap a bit with title
        .to(slides, {
            y: 0,
            opacity: 1,
            duration: 1.5,
            stagger: 0.5,
            ease: 'power2.out',
        }, '-=0.3'); // Start slides before nav finishes

        // Store animation reference
        carouselAnimations.set(carouselId, [tl]);

    }

    /**
     * Fix slide widths after Swiper initialization
     * @param {HTMLElement} carousel - The carousel container
     */
    function fixSlideWidths(carousel) {
        const slides = carousel.querySelectorAll(".swiper-slide");
        slides.forEach((slide) => {
            const container = slide.querySelector(
                ".contentcard-tile-container"
            );
            if (container) {
                if (container.classList.contains("tile-narrow")) {
                    slide.style.width = "260px";
                } else if (container.classList.contains("tile-wide")) {
                    slide.style.width = "355px";
                }
            }
        });
    }

    /**
     * Setup card interactions (flip, popup, video)
     * @param {HTMLElement} carousel - The carousel container
     */
    function setupCardInteractions(carousel) {
        setupCardFlip(carousel);
        setupPopupModal(carousel);
        setupVideo(carousel);
		setupTextOverlay(carousel);
    }

    /**
     * Setup card flip functionality with 3D animation
     * @param {HTMLElement} carousel - The carousel container
     */
    function setupCardFlip(carousel) {
        const cardFlips = carousel.querySelectorAll(
            ".contentcard-tile__cardflip"
        );

        cardFlips.forEach((card) => {
            const frontBtn = card.querySelector(
                ".cardtile-description .cardtile-btn"
            );
            const backBtn = card.querySelector(
                ".cardtile-flipcontent .cardtile-btn"
            );

            // Make sure the flip content is visible (but hidden by backface-visibility)
            const backContent = card.querySelector(".cardtile-flipcontent");
            if (backContent && backContent.style.display === "none") {
                backContent.style.display = "";
            }

            // Front to back flip
            if (frontBtn) {
                frontBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent swiper from capturing the click
                    card.classList.add("flipped");
                });
            }

            // Back to front flip
            if (backBtn) {
                backBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent swiper from capturing the click
                    card.classList.remove("flipped");
                });
            }
        });
    }

	/**
	 * Setup popup modal functionality
	 * @param {HTMLElement} carousel - The carousel container
	 */
	function setupPopupModal(carousel) {
		
		// Skip execution in author mode
		if(isAuthor) {
		return;
		}
		
		// Find all popup cards in this carousel
		const popupCards = carousel.querySelectorAll('.contentcard-tile__popup');
		
		// Find all modals in the document - they could be direct children of the carousel or moved to the body
		const allModals = document.querySelectorAll('.contentcard-modal:not(.contentcard-modal-author-mode)');
		
		// Reset all modals to ensure they're hidden
		allModals.forEach(modal => {
		modal.style.display = 'none';
		});
		
		// Setup each popup card
		popupCards.forEach((card, index) => {
		
		const popupBtn = card.querySelector('.cardtile-btn');
		if (!popupBtn) {
			return;
		}
		
		// Get the parent slide to find the card's position within all the slides
		const parentSlide = card.closest('.swiper-slide');
		if (!parentSlide) {
			return;
		}
		
		// Get all slides in this carousel
		const allSlides = carousel.querySelectorAll('.swiper-slide');
		
		// Find the index of this slide within all slides
		const slidePosition = Array.from(allSlides).indexOf(parentSlide);
		
		// Count popup cards up to this position to determine which modal should be associated
		let popupCardsBefore = 0;
		for (let i = 0; i < slidePosition; i++) {
			if (allSlides[i].querySelector('.contentcard-tile__popup')) {
			popupCardsBefore++;
			}
		}
		
		
		// Find modal by data-modal-index attribute
		let modal = null;
		
		// Get all modals for this carousel to ensure we match correctly
		// First try to find modals inside the carousel
		const carouselModals = Array.from(carousel.querySelectorAll('.contentcard-modal:not(.contentcard-modal-author-mode)'));
		
		if (carouselModals.length > 0 && popupCardsBefore < carouselModals.length) {
			// Use the modal that corresponds to this card's position among popup cards
			modal = carouselModals[popupCardsBefore];
		}
		
		// If no modal found inside the carousel, look for modals with specific data-modal-index
		if (!modal) {
			// Extract parResource from modal's data-modal-index attribute
			const modalsByIndex = Array.from(allModals);
			
			if (popupCardsBefore < modalsByIndex.length) {
			modal = modalsByIndex[popupCardsBefore];
			}
		}
		
		if (!modal) {
			console.error(`No modal found for card ${index}`);
			return;
		}
		
		// Get the modal identifier for logging
		const modalId = modal.getAttribute('data-modal-index');
		
		// Store a reference to the modal and its original parent/nextSibling for restoration
		card.modalReference = modal;
		card.modalOriginalParent = modal.parentNode;
		card.modalOriginalNextSibling = modal.nextSibling;
		
		// Create a new clean button to avoid any existing event handlers
		const newBtn = popupBtn.cloneNode(true);
		popupBtn.parentNode.replaceChild(newBtn, popupBtn);
		
		// Setup click handler
		newBtn.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			
			// Get the modal from the card reference
			const targetModal = card.modalReference;
			
			// Debugging: check if the modal exists before trying to open it
			if (!targetModal) {
			console.error('No modal associated with this button');
			return false;
			}
			
			// Move the modal to body for better positioning if not already there
			if (targetModal.parentNode !== document.body) {
			document.body.appendChild(targetModal);
			}
			
			// Set inline styles directly
			targetModal.style.cssText = 'display: flex !important; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999;';
			
			// Force reflow
			void targetModal.offsetWidth;
			
			// Reinitialize text highlight animations for modal content
			if (typeof window.reinitializeTextHighlightAnimation === 'function') {
				window.reinitializeTextHighlightAnimation(targetModal);
			}
			
			// Setup close button
			const closeBtn = targetModal.querySelector('.contentcard-modal-close');
			if (closeBtn) {
			// Remove existing handlers by cloning
			const newCloseBtn = closeBtn.cloneNode(true);
			closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
			
			newCloseBtn.addEventListener('click', function(evt) {
				evt.preventDefault();
				evt.stopPropagation();
				targetModal.style.display = 'none';
				
				// Move modal back to its original position
				if (card.modalOriginalParent && card.modalOriginalNextSibling) {
				card.modalOriginalParent.insertBefore(targetModal, card.modalOriginalNextSibling);
				} else if (card.modalOriginalParent) {
				card.modalOriginalParent.appendChild(targetModal);
				}
			});
			} else {
			console.error('No close button found in modal');
			}
			
			// Handle background click - use once option to ensure it only fires once
			targetModal.addEventListener('click', function(evt) {
			if (evt.target === targetModal) {
				targetModal.style.display = 'none';
				
				// Move modal back to its original position
				if (card.modalOriginalParent && card.modalOriginalNextSibling) {
				card.modalOriginalParent.insertBefore(targetModal, card.modalOriginalNextSibling);
				} else if (card.modalOriginalParent) {
				card.modalOriginalParent.appendChild(targetModal);
				}
			}
			});
			
			// Prevent default again for good measure
			return false;
		});
		});
		
		// Add global handler to ensure modals can be closed with escape key
		document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			const openModals = document.querySelectorAll('.contentcard-modal[style*="display: flex"]');
			openModals.forEach(modal => {
			modal.style.display = 'none';
			
			// Find the card that owns this modal and restore its position
			const allCarousels = document.querySelectorAll('.cmp-flindersonline-contentcard-carousel');
			allCarousels.forEach(carousel => {
				const popupCards = carousel.querySelectorAll('.contentcard-tile__popup');
				popupCards.forEach(card => {
				if (card.modalReference === modal) {
					if (card.modalOriginalParent && card.modalOriginalNextSibling) {
					card.modalOriginalParent.insertBefore(modal, card.modalOriginalNextSibling);
					} else if (card.modalOriginalParent) {
					card.modalOriginalParent.appendChild(modal);
					}
				}
				});
			});
			});
		}
		});
	}

  /**
 * Setup text overlay functionality with animation
 * @param {HTMLElement} carousel - The carousel container
 */
function setupTextOverlay(carousel) {
    const textOverlayCards = carousel.querySelectorAll('.contentcard-tile__textoverlay');
    
    textOverlayCards.forEach((card) => {
        const toggleBtn = card.querySelector('.cardtile-btn');
        const description = card.querySelector('.text-overlay-description');
        const content = card.querySelector('.text-overlay-content');
        
        if (!toggleBtn || !description || !content) return;
        
        // Set initial state
        let isContentVisible = false;
        
        // Ensure initial state
        content.style.display = 'none';
        content.style.opacity = '0';
        
        toggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (!isContentVisible) {
                // Show overlay content
                card.classList.add('overlay-active');
                
                // Animate description out
                description.style.transition = 'opacity 0.3s ease';
                description.style.opacity = '0';
                
                // Wait for description to fade out, then show content
                setTimeout(() => {
                    description.style.display = 'none';
                    content.style.display = 'block';
                    
                    // Force reflow
                    void content.offsetWidth;
                    
                    // Animate content in
                    content.style.transition = 'opacity 0.3s ease';
                    content.style.opacity = '1';
                    
                    // Additional delay to ensure content is fully visible before reinitializing animation
                    setTimeout(() => {
                        // Reinitialize text highlight animations for overlay content
                        if (typeof window.reinitializeTextHighlightAnimation === 'function') {
                            window.reinitializeTextHighlightAnimation(card);
                        }
                    }, 100);
                }, 300);
                
                // Rotate button to X
                toggleBtn.style.transform = 'rotate(45deg)';
                isContentVisible = true;
            } else {
                // Hide overlay content
                card.classList.remove('overlay-active');
                
                // Animate content out
                content.style.transition = 'opacity 0.3s ease';
                content.style.opacity = '0';
                
                // Wait for content to fade out, then show description
                setTimeout(() => {
                    content.style.display = 'none';
                    description.style.display = 'block';
                    
                    // Force reflow
                    void description.offsetWidth;
                    
                    // Animate description in
                    description.style.transition = 'opacity 0.3s ease';
                    description.style.opacity = '1';
                    
                    // Additional delay to ensure description is fully visible before reinitializing animation
                    setTimeout(() => {
                        // Reinitialize text highlight animations for description content
                        if (typeof window.reinitializeTextHighlightAnimation === 'function') {
                            window.reinitializeTextHighlightAnimation(card);
                        }
                    }, 100);
                }, 300);
                
                // Reset button rotation
                toggleBtn.style.transform = 'rotate(0deg)';
                isContentVisible = false;
            }
        });
    });
}

    /**
     * Setup video functionality
     * @param {HTMLElement} carousel - The carousel container
     */
    function setupVideo(carousel) {
        const videoCards = carousel.querySelectorAll(
            ".contentcard-tile__video"
        );

        videoCards.forEach((card) => {
            const videoPath = card.getAttribute("data-video-path");
            const playBtn = card.querySelector(".video-play-btn");
            const placeholder = card.querySelector(".video-placeholder");

            if (playBtn && placeholder && videoPath) {
                playBtn.addEventListener("click", function (e) {
                    e.preventDefault();

                    // Check if video already exists to prevent duplicates
                    const existingVideo = card.querySelector(".video-player");
                    if (existingVideo) {
                        // If video exists, just play it
                        existingVideo.play();
                        return;
                    }

                    // Pause all other videos in the carousel before creating a new one
                    const allVideos = carousel.querySelectorAll(".video-player");
                    allVideos.forEach(video => {
                        video.pause();
                        video.currentTime = 0;
                    });

                    // Create video element
                    const video = document.createElement("video");
                    video.className = "video-player";
                    video.src = videoPath;
                    video.controls = true;
                    video.disablePictureInPicture = true;
                    video.controlsList = "nodownload noplaybackrate nofullscreen";
                    video.autoplay = true;
                    video.preload = "metadata";

                    // Add event listeners for proper video management
                    video.addEventListener('loadstart', function() {
                    });

                    video.addEventListener('canplay', function() {
                    });

                    video.addEventListener('pause', function() {
                        // Ensure audio is actually stopped
                        this.muted = true;
                        setTimeout(() => {
                            this.muted = false;
                        }, 100);
                    });

                    video.addEventListener('play', function() {
                        // Pause all other videos when this one starts playing
                        const otherVideos = document.querySelectorAll(".video-player");
                        otherVideos.forEach(otherVideo => {
                            if (otherVideo !== this && !otherVideo.paused) {
                                otherVideo.pause();
                                otherVideo.currentTime = 0;
                            }
                        });
                    });

                    video.addEventListener('ended', function() {
                        // Optionally reset to beginning or show placeholder again
                        this.currentTime = 0;
                    });

                    video.addEventListener('error', function(e) {
                        console.error('Video error:', e);
                    });

                    // Replace placeholder with video
                    card.replaceChild(video, placeholder);
                });
            }
        });
    }

    /**
     * Setup ResizeObserver to monitor viewport changes
     */
    function setupResizeObserver() {
        // Check if ResizeObserver is supported
        if ("ResizeObserver" in window) {
            // Create a resize observer for carousel containers only
            const resizeObserver = new ResizeObserver(
                debounce(function (entries) {
                    // Only reinitialize if there are significant width changes (ignore height changes from other content)
                    let shouldReinitialize = false;
                    
                    entries.forEach(entry => {
                        const width = entry.contentRect.width;
                        
                        // Only check width changes, ignore height changes to prevent tab content interference
                        if (Math.abs(width - (entry.target._lastWidth || width)) > 100) {
                            shouldReinitialize = true;
                        }
                        
                        // Store current dimensions
                        entry.target._lastWidth = width;
                    });
                    
                    if (shouldReinitialize) {
                        initContentCardCarousels();
                    }
                }, 500) // Increased debounce delay
            );

            // Observe each carousel container instead of the body
            const carousels = document.querySelectorAll('.cmp-flindersonline-contentcard-carousel');
            carousels.forEach(carousel => {
                resizeObserver.observe(carousel);
            });
        } else {
            // Fallback for browsers that don't support ResizeObserver
            window.addEventListener(
                "resize",
                debounce(function () {
                    // Only reinitialize on significant window resize
                    const currentWidth = window.innerWidth;
                    const currentHeight = window.innerHeight;
                    
                    if (!window._lastWindowSize) {
                        window._lastWindowSize = { width: currentWidth, height: currentHeight };
                        return;
                    }
                    
                    const widthDiff = Math.abs(currentWidth - window._lastWindowSize.width);
                    const heightDiff = Math.abs(currentHeight - window._lastWindowSize.height);
                    
                    if (widthDiff > 100 || heightDiff > 500) {
                        window._lastWindowSize = { width: currentWidth, height: currentHeight };
                        initContentCardCarousels();
                    }
                }, 500)
            );
        }
    }

    /**
     * Debounce function to limit the rate at which a function can fire
     * @param {Function} func - The function to debounce
     * @param {number} wait - The debounce wait time in milliseconds
     * @return {Function} - Debounced function
     */
    function debounce(func, wait) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                func.apply(context, args);
            }, wait);
        };
    }

    // Expose a global function to pause all videos
    window.pauseAllCarouselVideos = function() {
        const allVideos = document.querySelectorAll('.video-player');
        allVideos.forEach(video => {
            if (!video.paused) {
                video.pause();
            }
        });
    };

    // Expose a global function to reinitialize carousel animations
    window.reinitCarouselAnimations = function(carouselElement = null) {
        if (isAuthor) {
            return;
        }

        if (carouselElement) {
            // Reinitialize animations for specific carousel
            initCarouselAnimations(carouselElement);
        } else {
            // Reinitialize animations for all carousels
            const carousels = document.querySelectorAll('.cmp-flindersonline-contentcard-carousel');
            carousels.forEach(carousel => {
                initCarouselAnimations(carousel);
            });
        }
    };

    // Execute when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            initContentCardCarousels();
            setupResizeObserver();
        });
    } else {
        // If already loaded, run immediately
        requestAnimationFrame(function () {
            initContentCardCarousels();
            setupResizeObserver();
        });
    }
})(); // End IIFE
